import React, { useState } from "react";
import Common_Back_Btn from "../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import Retesting_Testing_Filter from "./retesting_testing_filter/Retesting_Testing_Filter";
import Retesting_Testing_Table from "./retesting_testing_table/Retesting_Testing_Table";

const Retesting_Testing = () => {
  const [show, setShow] = useState(false);

  return (
    <section className="Sample_Report">
    

      <div className="Sample_Report_Filter_div">
        <Retesting_Testing_Filter setShow={setShow} />
      </div>

      <div className="report_table_div">
        <Retesting_Testing_Table />
      </div>

      <Common_Report_Offcanvas
        title={"Measurement Uncertainty Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Retesting_Testing;
